const convertToClass = (classString) => `.${classString}`;

export default convertToClass;
